import React, { useCallback } from 'react';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import Link from '@material-ui/core/Link';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';
import Grid from '@material-ui/core/Grid';

import menuItems, { MenuItemType, } from './menuItems';
import BoxComponentWrapper from 'common/components/BoxComponentWrapper';
import IsLogged from 'common/components/IsLogged';
import SvgIcon from 'common/components/SvgIcon';
import logoGwo from 'assets/icons/logo_gwo_sygnet.svg';
import { PORTAL_GWO_LINK } from 'common/constants';

type Props = {
    isDrawerActive: boolean,
    setDrawerOpenState: Function,
};

const Drawer: React.FC<Props> = ({
    isDrawerActive,
    setDrawerOpenState,
}) => {
    const redirect = useCallback(
        (url, method = 'push') => () => {
            const location = window.location;
            switch (method) {
                case 'push':
                    location.href = url;
                    break;
                case 'replace':
                    location.replace(url);
                    break;
                default:
                    console.error(`Method ${method} doesn't exist.`);
                    break;
            }
        },
        [],
    );

    const renderMenuItems = useCallback(
        ({ text, url, method, }: MenuItemType) => (
            <ListItem key={text}
                      onClick={redirect(url, method)}
                      button>
                <ListItemText primary={text} />
            </ListItem>
        ),
        [ redirect, ]
    );

    return (
        <SwipeableDrawer open={isDrawerActive}
                         onClose={setDrawerOpenState(false)}
                         onOpen={setDrawerOpenState(true)}>
            <Box width={250}
                 component={List}
                 onClick={setDrawerOpenState(false)}>
                <Box component={BoxComponentWrapper(<Grid container
                                                          direction="row"
                                                          justify="space-between"
                                                          alignItems="center" />)}
                     px={2}>
                    <Link href={PORTAL_GWO_LINK}>
                        <SvgIcon src={logoGwo}
                            height={45} />
                    </Link>
                    <CloseIcon onClick={setDrawerOpenState(false)} />
                </Box>

                <IsLogged>
                    {menuItems.map(renderMenuItems)}
                </IsLogged>
            </Box>
        </SwipeableDrawer>
    );
};

export default Drawer;
